import React from 'react'
import {DjangoField} from 'championship/src/components/Fields/Field'
import {useAtom, useCtx} from '@reatom/npm-react'
import MembersTable from 'championship/src/components/TournamentForm/MembersTable'
import MembersList from 'championship/src/components/TournamentForm/MembersList'
import {
  changeTabAction,
  saveAction,
  getModelSchema, tournamentIdAtom
} from '../../model'

function TabMembers({model}) {
  const ctx = useCtx()
  const tab = getModelSchema(model)
  const [tournamentId, ] = useAtom(tournamentIdAtom)

  return (
    <div className="reactive-form-tab-body" ref={tab.ref_body}>
      <div className="reactive-form-tab-body__inner">
        <div className="f-row">
          <div className="f-col f-col-lg-3 f-col-12">
            <div className="page-heading -underline">
              Участники
            </div>
          </div>
          <div className="f-col f-col-lg-9 f-col-12">
            <div className="f-row f-g-4">
              <div className="f-col f-col-12">
                <div className="f-row f-g-4">
                  <div className="f-col f-col-lg-4 f-col-12">
                    <DjangoField
                      model="format:tournament.competition_format"
                      label=""
                      need_external_label={false}
                      required={false}
                      ctx={ctx}
                    />
                  </div>
                  <div className="f-col f-col-lg-8 f-col-12">
                    <div className="reactive-form-flex-row">
                      <DjangoField
                        model="tournament.hidden"
                        ctx={ctx}
                        label="Скрыть турнир"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="f-col f-col-12">
                                <SearchSelect
                                    id="tab_members"
                                    ctx={ctx}
                                    atom={participantsAtom}
                                    />
                            </div> */}
              <div className="f-col f-col-12">
                <MembersList/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="reactive-form-buttons">
        <button className="button" onClick={() => {
          changeTabAction(ctx, -1)
        }}>
          Назад
        </button>
        <button className="button -fill" onClick={() => {
          saveAction(ctx)
        }}>
          Сохранить
        </button>
      </div>

      {tournamentId && <MembersTable/>}
    </div>
  )
}

export default TabMembers